import { render, staticRenderFns } from "./ChangePasswd.vue?vue&type=template&id=41c64982"
import script from "./ChangePasswd.vue?vue&type=script&lang=js"
export * from "./ChangePasswd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports